import React from 'react';
import { Nav } from "@/components/navigation/Navbar";
import CallToAction from '@/components/catalog/CallToAction';

export default function Newsletter() {
  return (
    <div className="section">

      <CallToAction />
    </div>
  );
}


Newsletter.getLayout = function getLayout(page) {
  return (
    <div>
      <div className="amb-container bg-white">
        <Nav theme="light" />
      </div>
      <div>{page}</div>
    </div>
  );
};